<script>
	import { lotFace, lotSide, lotRear } from "./stores.js";
	import NumInput from "./NumInput.svelte";

	let imgSlug = "build";
	let iconalt = "Setbacks";

	$: {
		iconalt = imgSlug === "build" ? "Setbacks" : imgSlug + " yard setback";
	}

	function handleFocus(e) {
		let slug = e.target.id;
		imgSlug = slug;
	}

	function handleBlur() {
		imgSlug = "build";
	}
</script>

<h3>Setback Dimensions</h3>

<div class="input-group">
	<div class="set-icon">
		<img src="./img/{imgSlug}-graphic.svg" alt={iconalt}>
	</div>
	<div class="inputs">
		<NumInput label="Front Yard (ft)" bind:val={$lotFace} id="front" on:focus={handleFocus} on:blur={handleBlur} />
		<NumInput label="Side Yard (ft)" bind:val={$lotSide} id="side" on:focus={handleFocus} on:blur={handleBlur} />
		<NumInput label="Rear Yard (ft)" bind:val={$lotRear} id="rear" on:focus={handleFocus} on:blur={handleBlur} />
	</div>
</div>
